import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-handle",
  "use": "icon-handle-usage",
  "viewBox": "0 0 64.6 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64.6 64\" id=\"icon-handle\">\r\n<path d=\"M17.5,14.2c-3.3,0-5.9-2.7-5.9-5.9s2.7-5.9,5.9-5.9l0,0c3.3,0,5.9,2.7,5.9,5.9S20.8,14.2,17.5,14.2z M47.1,14.2\r\n\tc-3.3,0-5.9-2.7-5.9-5.9s2.7-5.9,5.9-5.9l0,0C50.4,2.4,53,5,53,8.3S50.4,14.2,47.1,14.2z M17.5,37.9c-3.3,0-5.9-2.7-5.9-5.9\r\n\ts2.7-5.9,5.9-5.9l0,0c3.3,0,5.9,2.7,5.9,5.9S20.8,37.9,17.5,37.9z M47.1,37.9c-3.3,0-5.9-2.7-5.9-5.9s2.7-5.9,5.9-5.9l0,0\r\n\tc3.3,0,5.9,2.7,5.9,5.9S50.4,37.9,47.1,37.9z M17.5,61.6c-3.3,0-5.9-2.7-5.9-5.9c0-3.3,2.7-5.9,5.9-5.9l0,0c3.3,0,5.9,2.7,5.9,5.9\r\n\tC23.4,59,20.8,61.6,17.5,61.6z M47.1,61.6c-3.3,0-5.9-2.7-5.9-5.9c0-3.3,2.7-5.9,5.9-5.9l0,0c3.3,0,5.9,2.7,5.9,5.9\r\n\tC53,59,50.4,61.6,47.1,61.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/handle.svg
// module id = cnev
// module chunks = 164